import { render, staticRenderFns } from "./loadingBalls.vue?vue&type=template&id=7b5da288&scoped=true"
import script from "./loadingBalls.vue?vue&type=script&lang=js"
export * from "./loadingBalls.vue?vue&type=script&lang=js"
import style0 from "./loadingBalls.vue?vue&type=style&index=0&id=7b5da288&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5da288",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/social-login-buttons/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b5da288')) {
      api.createRecord('7b5da288', component.options)
    } else {
      api.reload('7b5da288', component.options)
    }
    module.hot.accept("./loadingBalls.vue?vue&type=template&id=7b5da288&scoped=true", function () {
      api.rerender('7b5da288', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loadingBalls.vue"
export default component.exports